import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCallback } from "react";

function useNavigator() {
  return useCallback(
    () => ({
      href: {
        pathname: "/(nav)/(app)/learn/map",
      },
      // The map's outlines are bundled and its study data loads progressively, so there is
      // nothing to prefetch.
      queries: [],
    }),
    [],
  );
}

export const useMapPageNavigator = createPageNavigator<void>({
  useNavigator,
});
